import { makeStyles } from '@material-ui/core/styles';

export default () => {
    return makeStyles(theme => ({
        root: {
            padding: 20
        }
    }));
};
